import { JSXElement, mergeProps, Show } from 'solid-js';

type DividerProps = {
  vertical?: boolean;
  showOr?: boolean;
};

export default function Divider(props: DividerProps): JSXElement {
  const merged = mergeProps(
    {
      vertical: false,
      showOr: false
    },
    props
  );
  return (
    <div
      class={`relative`}
      classList={{
        'w-0.25 h-full mx-6': merged.vertical,
        'w-full h-0.25 my-6': !merged.vertical,
        'bg-bg-emphasized': true
      }}
    >
      <Show when={merged.showOr}>
        <span
          class={`absolute text-xs px-2 bg-bg-canvas text-fg-muted left-[50%] top-[50%] -ml-4 -mt-[7px]`}
        >
          OR
        </span>
      </Show>
    </div>
  );
}
